export default {
    devices_bulk_actions_title: "Bulk Actions",
    devices_bulk_actions_account: "Account",
    devices_bulk_actions_manufacturer: "Manufacturer",
    devices_bulk_actions_device_model: "Device Model",
    devices_bulk_actions_sim_provider: "SIM Provider",
    devices_bulk_actions_device_name: "Device Name",
    devices_bulk_actions_imei: "IMEI",
    devices_bulk_actions_serial: "Serial",
    devices_bulk_actions_script: "Script",
    devices_bulk_actions_devices_will_be_affected: "Device(s) will be affected",
    devices_bulk_actions_promiles: "Promiles",
    devices_bulk_actions_analytics: "Analytics",
    devices_bulk_actions_show_ecu_speed: "Show ECU Speed",
    devices_bulk_actions_use_ecu_odometer: "Use ECU Odometer",
    devices_bulk_actions_device_category: "Device Category",
    devices_bulk_actions_send_command: "Send Command",
    devices_bulk_actions_fleet: "Fleet",
    devices_bulk_actions_asset: "Asset",
    devices_bulk_actions_send_command_via: "Send Command Via",
    devices_bulk_actions_sms: "SMS",
    devices_bulk_actions_ota: "OTA",
    devices_bulk_actions_open_command: "Open Command",
    devices_bulk_actions_command: "Command",
    devices_bulk_actions_raw_command: "Raw Command",
    devices_bulk_send_command_via: "Send Command Via",
    devices_bulk_yes: "Yes",
    devices_bulk_no: "No",
    devices_bulk_sim_provider_account: "SIM Provider Account",
    devices_bulk_active: "Active",
    devices_bulk_inactive: "Inactive",
    devices_bulk_enabled: "Enabled",
    devices_bulk_disabled: "Disabled",
    devices_bulk_driver_behavior: "Driver Behavior",
    devices_bulk_it_is_necessary_to_select_an_account: "It is necessary to select an account",
    devices_bulk_the_features_have_been_edited: "The features have been edited",
    devices_bulk_it_was_not_possible_to_update_the_features: "It was not possible to update the features",
    devices_bulk_apply_changes: "Apply Changes",
    devices_bulk_the_device_model_of_the_selected_devices: "The Device model of the selected devices must be the same",
    devices_bulk_the_unit_id_be_the_same: "The unit id must be the same",
    devices_bulk_you_have_no_devices_selected: "You have no devices selected",
    devices_bulk_you_must_select_a_sim_provider_account: "You must select a SIM Provider Account",
    devices_bulk_the_command_has_been_sent: "The command has been sent",
    devices_bulk_an_error_occurred_while_sending_the_command: "An error occurred while sending the command",
    devices_bulk_you_must_apply_some_changes: "You must apply some changes to the configuration",
    devices_bulk_smartWitness_error: "It is not possible to make changes to SmartWitness manufacturer's devices",
    devices_bulk_sim_timezone: "Time Zone",
    devices_bulk_features: "Bulk Features",
    devices_bulk_actions_show:"Show In Web",
    devices_bulk_actions_linked_mode:"Mode",
    devices_bulk_actions_linked_mode_pair:"Paired",
    devices_bulk_actions_linked_mode_camera:"As GPS",
    devices_bulk_actions_send_calc_odometer:"Send Calc Odometer",
    devices_bulk_actions_apu:"Apu",
    devices_bulk_actions_hybrid:"Hybrid",
    devices_bulk_actions_use_ecu_vin:"Use Ecu Vin",
    devices_bulk_actions_tags:"Tags",
    devices_bulk_actions_message: "The request to update the devices has been sent successfully, please check the transactions list to see the status of the request.",
    devices_bulk_select_command_for_each_group: "Please select one command for each group.",
    devices_bulk_unit_type: "Unit Type",
    devices_bulk_command_entity_label: "{entity}: {name}",
    devices_bulk_devices_count: "Devices affected: {count}",
    devices_bulk_no_commands_available: "No commands available for the selected groups.",

}





